import Base from './base'

export default class CreateLogCall extends Base {
  createCallLog(payload: Record<string, unknown>): Promise<unknown> {
    return this.api.post('activities/calls', payload)
  }
}
